module.exports = __webpack_public_path__ + "static/media/COS_BIOSYNEX.bb7126ab.jpg";